import React, { useState } from "react";
import { Gift, Copy, Check } from "lucide-react";
import { useAccess } from "@/context/AccessContext";
import { copyToClipboard } from "@/lib/share";

export function WinBackBanner() {
  const { winback } = useAccess();
  const [copied, setCopied] = useState(false);
  if (!winback) return null;
  const until = new Date(winback.expires_at).toLocaleDateString(undefined, { month: "short", day: "numeric" });
  const copy = async () => {
    if (!(await copyToClipboard(winback.code, "Code copied — paste it in the promo box at checkout"))) return;
    setCopied(true); setTimeout(() => setCopied(false), 1500);
  };
  return (
    <div data-testid="winback-banner" className="mt-6 rounded-lg border border-oracle/40 bg-oracle/10 p-4 flex flex-col sm:flex-row sm:items-center gap-3">
      <div className="w-9 h-9 rounded-full bg-oracle/15 border border-oracle/40 flex items-center justify-center shrink-0"><Gift className="w-4 h-4 text-oracle" strokeWidth={1.5} /></div>
      <div className="flex-1">
        <div className="font-heading text-lg text-parchment">Welcome back — <span className="italic text-oracle">{winback.percent_off}% off for {winback.months} months</span></div>
        <p className="font-body text-xs text-parchment/60 mt-0.5">Your one-time code. Enter it in the “Add promotion code” box on the Stripe checkout page. Valid until {until}.</p>
      </div>
      <button data-testid="winback-code-btn" onClick={copy} className="flex items-center gap-2 bg-black/40 border border-oracle/40 rounded-md px-3 py-2 font-body text-sm tracking-widest text-oracle hover:bg-oracle/15 transition-colors">
        <span data-testid="winback-code">{winback.code}</span>{copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
      </button>
    </div>
  );
}
